import React from 'react';
import { ValidationIcon } from '../../../icons';
import { handleCpfMaskOnInput } from '../../../../utils/payment/masks';

interface CpfFieldProps {
  value: string;
  error?: string;
  isValid: boolean;
  cpfOnIdentification: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const CpfField: React.FC<CpfFieldProps> = ({
  value,
  error,
  isValid,
  cpfOnIdentification,
  onChange,
}) => {
  if (!cpfOnIdentification) {
    return null;
  }

  const inputBaseClass = 'w-full p-3 border rounded-md shadow-sm text-sm focus:ring-primary focus:border-primary bg-input-bg-light dark:bg-input-bg-dark text-text-primary dark:text-gray-200 placeholder-gray-400 dark:placeholder-gray-500';
  const errorBorderClass = 'border-red-500';
  const normalBorderClass = 'border-medium-gray dark:border-gray-600';

  return (
    <div className="relative">
      <label htmlFor="cpf" className="block text-sm font-medium text-text-secondary dark:text-gray-400 mb-1">
        CPF *
      </label>
      <div className="relative">
      <input
        type="text"
        name="cpf"
        id="cpf"
        value={value}
        onChange={onChange}
        placeholder="000.000.000-00"
        maxLength={14}
        minLength={11}
        onInput={handleCpfMaskOnInput}
        className={`${inputBaseClass} ${error ? errorBorderClass : normalBorderClass}`}
        aria-describedby={error ? 'cpf-error' : undefined}
      />
      <ValidationIcon isValid={Boolean(isValid && value)} />
      {error && (
        <p id="cpf-error" className="text-xs text-red-500 mt-1">
          {error}
        </p>
      )}
      </div>
    </div>
  );
};

export default CpfField; 